<div class="container error-container">
  <div class="fs-4 error-container__icon-container d-inline-flex">
    <span class="mt-1">
      <ebook-error-component-icon></ebook-error-component-icon>
    </span>
    <h1 class="d-flex align-items-center ms-4">
      {{ "GENERIC.ERROR.HEADING" | translate }}
    </h1>
  </div>
  @if (!isErrorWithLink()) {
    <h2 class="error-container__icon-container--error-text fw-semibold">
      {{ errorMessageKey() | translate }}
    </h2>
  } @else {
    <p class="error-container__icon-container--error-text fw-semibold">
      {{ errorMessageKey() | translate }}
      <a href="{{ techSupportUrl() }}" class="link" target="_blank">
        <span class="link">
          {{ errorMessageLinkLabelKey() | translate }}
        </span>
      </a>
    </p>
  }

  <div>
    <button
      type="button"
      (click)="onExitClick()"
      [disabled]="buttonDisabled()"
      class="btn btn-primary mt-2">
      {{ buttonTranslationKey() | translate }}
    </button>
  </div>
</div>
